import type { CreatorVideoMapKey } from '@newo/tenant-metadata';

export const CREATOR_VIDEO_MAP_KEYS = {
	INTRO: 'intro',
	TRAINING_WAITING: 'training_waiting',
	SUCCESS_MODAL: 'success_modal',
	ACCOUNT_ACTIVATION: 'activate_account',
	NEXT_STEPS: 'next_steps_intro'
} as const satisfies Record<string, CreatorVideoMapKey>;
